import * as Sentry from '@sentry/react';
import { User } from './types';
import { getEnv } from '~/modules/@shared/helpers/env';
import { Scope } from '@sentry/react';

enum Errors {
  UNHANDLED_EXCEPTION = 'UNHANDLED_EXCEPTION',
  CREATE_OPEN_GYM_BOOKING_ERROR = 'CREATE_OPEN_GYM_BOOKING_ERROR',
  CREATE_CLASS_CHECK_IN_BOOKING_ERROR = 'CREATE_CLASS_CHECK_IN_BOOKING_ERROR',
  UPDATE_CLASS_CHECK_IN_BOOKING_ERROR = 'UPDATE_CLASS_CHECK_IN_BOOKING_ERROR',
}

class BaseError extends Error {
  private readonly errorStatus: string;
  public name: string;

  constructor(message: string, status: string) {
    super(message);
    this.errorStatus = status;
  }

  setBasicInfo(scope: Scope) {
    return scope.setContext('error', { error_status: this.errorStatus, error_message: this.message });
  }
}

class KioskCheckInError extends BaseError {
  public bookingArgs: Record<string, any>;
  constructor(message: string, status: string, name: Errors, bookingArgs: Record<string, any>) {
    super(message, status);
    this.bookingArgs = bookingArgs;
    this.name = name;
  }
}

const errorReporting = {
  init(config: Parameters<typeof Sentry.init>[0] = {}) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      debug: false,
      enabled: getEnv() === 'production',
      environment: getEnv(),
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 1.0,
      ...config,
    });
  },
  logUser(currentUser: User) {
    Sentry.setUser({
      id: currentUser.id,
    });
  },
  logoutUser() {
    Sentry.setUser(null);
  },
  logMessage(message: string) {
    return Sentry.captureMessage(message);
  },
  logError(e: Error) {
    return Sentry.captureException(e);
  },
  logKioskCheckInError(e: KioskCheckInError) {
    return Sentry.withScope((scope) => {
      scope.setTag('kiosk', 'check_in');
      scope.setContext('booking_args', e.bookingArgs);

      return e.setBasicInfo(scope).captureException(e);
    });
  },
};

export { errorReporting, Errors, KioskCheckInError };
